define([
  'es6!sumo/util',
  'immutable',
  'underscore',
  'moment',
  'es6!launcher/actions/DisplayRuleActions',
], (Util, Immutable, _, moment, Actions) => {
  const initialState = Immutable.Map({
    byObjectId: Immutable.Map(),
    isDisplayRulesChanged: false,
  });

  const actionHandlers = {};

  actionHandlers[Actions.RECEIVE_DISPLAY_RULES] = (state, action) => {
    const { isDisplayRulesChanged } = action;
    // Add group_id to all rules if they don't have one. We manipulate rule groups rather than
    // individual groups so we need a way to identify groups.

    const rules = action.rules.map((r) => {
      const rule = r;

      if (!rule.group_id) rule.group_id = `new-${Util.generateId64()}`;

      if (rule.filter_type === 'date') {
        let dateObj = null;
        try {
          dateObj = JSON.parse(rule.filter_value);
        } catch (err) {
          // Already an object
          dateObj = rule.filter_value;
        }

        dateObj.time = moment(dateObj.time);
        rule.filter_value = dateObj;
      }

      return rule;
    });

    const newRulesByObjectId = _.groupBy(rules, 'object_id');
    let newState = state;

    _.each(newRulesByObjectId, (rulesForObjectId, objectId) => {
      const rulesByGroupId = _.groupBy(rulesForObjectId, 'group_id');
      newState = newState.setIn(['byObjectId', objectId], Immutable.fromJS(rulesByGroupId));
    });

    return newState.merge(
      Immutable.Map({
        isDisplayRulesChanged: isDisplayRulesChanged === true,
      }),
    );
  };

  actionHandlers[Actions.UPDATE_DISPLAY_RULE_GROUP] = (state, action) => {
    const groupId = action.groupId;
    const rules = action.rules;

    if (!rules || !rules.length) return state;

    const objectId = rules[0].object_id;

    const retState = state.setIn(['byObjectId', objectId, groupId], Immutable.fromJS(rules));
    return retState.merge(Immutable.Map({ isDisplayRulesChanged: true }));
  };

  actionHandlers[Actions.DELETE_DISPLAY_RULE_GROUP] = (state, action) => {
    const objectId = action.objectId;
    const groupId = action.groupId;

    const retState = state.deleteIn(['byObjectId', objectId, groupId]);
    return retState.merge(Immutable.Map({ isDisplayRulesChanged: true }));
  };

  actionHandlers[Actions.UPDATE_DISPLAY_RULE_SETTING] = (state, action) => {
    const { setting, value } = action;

    const retState = state.merge(Immutable.Map({ isDisplayRulesChanged: true }));

    if (Array.isArray(setting)) return retState.setIn(setting, value);
    return retState.set(setting, value);
  };

  actionHandlers[Actions.DELETE_DISPLAY_RULE] = (state, action) => {
    const { displayRuleId, objectId, groupId } = action;

    // Get the existing rules for the given object id and group id
    const rulesForGroup = state.getIn(['byObjectId', objectId, groupId]);

    // Filter the given rule from the existing rules
    const newRulesForGroup = rulesForGroup.filter(rule => rule.get('id') !== displayRuleId);

    let newState = state;

    // If the given rule is the last in the group, just delete the group
    if (newRulesForGroup.size === 0) {
      newState = newState.deleteIn(['byObjectId', objectId, groupId]);
    } else {
      newState = newState.setIn(['byObjectId', action.objectId, action.groupId], newRulesForGroup);
    }

    return newState.merge(Immutable.Map({ isDisplayRulesChanged: true }));
  };

  return Util.createReducer(initialState, actionHandlers);
});
